import React from "react"

// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

// ** Custom Components
import Box from "../Box"
import Text from "../Text"

interface BlogCardProps {
  image: any
  type: string
  title: string
  href?: string
}
const BlogCard = ({ image, type, title, href = "#" }: BlogCardProps) => {
  return (
    <Box className="relative w-[280px] h-[350px]">
      <Link to={href} className="flex flex-col justify-between">
        <Box className="z-0 w-full h-60 rounded-md">
          {image ? (
            <GatsbyImage
              image={image}
              alt={title || "card"}
              objectFit="cover"
              className="shadow-lg h-full rounded-md overflow-hidden isolate"
              sizes="300px"
            />
          ) : null}
        </Box>
        <Box className="bottom-0 z-10 inset-x-0 h-28 text-center">
          <Text
            variant="label"
            className="text-orange-500 uppercase text-sm font-semibold pt-1"
          >
            {type}
          </Text>
          <Text
            variant="body-copy"
            className="leading-6 text-gray-700 hover:text-orange-500 transition-all"
          >
            {title}
          </Text>
        </Box>
      </Link>
    </Box>
  )
}

export default BlogCard
